import { useApiFetch } from './index'
import { ndjson } from './ndjson'

// Matches the treaty client's own default in `./index`; a bare host is not a valid `fetch` URL.
export const baseUrl = () => {
  const configured = process.env.API_URL ?? 'localhost:3002'
  return /^https?:\/\//.test(configured) ? configured : `http://${configured}`
}

const failureOf = async (response: Response) => {
  try {
    const body = (await response.json()) as { error?: unknown }
    if (typeof body.error === 'string') return body.error
  } catch {
    // An error body that is not JSON tells us nothing the status does not.
  }
  return `request failed with status ${response.status}`
}

export const useApiStream = () => {
  const fetcher = useApiFetch().fetch

  return async function* <T>(path: string, body: unknown, signal?: AbortSignal): AsyncGenerator<T> {
    const response = await fetcher(`${baseUrl()}${path}`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body),
      signal
    })
    if (!response.ok || !response.body) throw new Error(await failureOf(response))

    yield* ndjson<T>(response.body.pipeThrough(new TextDecoderStream()))
  }
}
